import { createServerFn } from "@tanstack/react-start";
import { getRequestHeader } from "@tanstack/react-start/server";
import { countryToJurisdiction, type Jurisdiction } from "./jurisdiction";

export type VisitorGeo = {
  country: string | null;
  jurisdiction: Jurisdiction;
  source: "cf-header" | "fallback";
};

/**
 * Reads CF-IPCountry (Cloudflare Workers injects it on every request).
 * Falls back to "DEFAULT" jurisdiction when running outside Cloudflare.
 */
export const getVisitorGeo = createServerFn({ method: "GET" }).handler(
  async (): Promise<VisitorGeo> => {
    const cf =
      getRequestHeader("CF-IPCountry") ||
      getRequestHeader("cf-ipcountry") ||
      getRequestHeader("x-vercel-ip-country") ||
      null;
    if (cf && cf.length === 2 && cf !== "XX" && cf !== "T1") {
      return { country: cf.toUpperCase(), jurisdiction: countryToJurisdiction(cf), source: "cf-header" };
    }
    return { country: null, jurisdiction: "DEFAULT", source: "fallback" };
  },
);
